import { request } from '@/shared/api/request'

export const getContacts = (payload) => {
	return request({ url: `dict/contacts/${payload.country}`, method: 'GET' })
}
